/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:inline-block;text-align:center;font-weight:700;border-radius:100%;background:#ffc82e;color:#fff;width:100px;height:100px;line-height:100px;font-size:40px}"];
export { styles as styles };
